import React from 'react';
import classNames from 'classnames';

import css from './Loader.scss';

const Size = {
	small: 'small',
	medium: 'medium',
	large: 'large',
} as const;

type Props = {
	size?: typeof Size[keyof typeof Size];
	color?: string;
	className?: string;
};

const Loader: React.FC<Props> & {
	size: typeof Size;
} = ({ size = 'medium', color = '#f9fffe', className = '' }: React.ComponentProps<typeof Loader>) => {
	return <div style={{ borderLeftColor: color }} className={classNames(css.loader, css[size], className)} />;
};

Loader.size = Size;

export default Loader;
